import component from "./TopVideos";
export default component;
